import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
  Button,
  Avatar,
  Box,
} from '@mui/material';
import { RemoveRedEyeOutlined, Visibility } from '@mui/icons-material';
import {
  capitalizeWords,
  DateDDMMYYYY,
  formatDateAndTime,
  getStatusLabel,
  lockWidth,
} from '../../../utils/helper';
import { IBrand } from '../../../utils/entities/interface';
import { useNavigate } from 'react-router-dom';
import { DialogBoxComp } from '../../atoms/DialogBox';
import { SkeletonRows } from '../../skeletons/list';
import { ToggleBrandStatus } from '../../../services/brands';
import { ModalConfirmation } from '../../molecules/ModalConfirmation';
import { ListTable } from '../../molecules/ListTable';
import { on } from 'events';

export const BrandList = ({
  brands,
  onUpdate,
  isLoading,
  headerCells,
}: {
  brands: IBrand[];
  onUpdate: () => void;
  isLoading: boolean;
  headerCells: [string, number][];
}) => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [selectedbrand, setSelectedBrand] = useState<IBrand | null>(null);

  const handleOpen = (user: IBrand) => {
    setSelectedBrand(user);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setSelectedBrand(null);
  };

  const handleConfirm = async () => {
    if (selectedbrand) {
      try {
        await ToggleBrandStatus(selectedbrand._id);
        onUpdate();
        handleClose();
      } catch (error) {
        alert(
          error instanceof Error ? error.message : 'Failed to update status',
        );
      }
    }
  };

  const actions = [
    {
      icon: <RemoveRedEyeOutlined />,
      // onClick: (row: IBrand) => onManageClick(row._id),
      onClick: (row: IBrand) =>
        navigate(`/manage/brand-errors/${row._id}`, {
          state: { brandName: row.name },
        }),
    },
  ];
  const handleOpenModal = (brand: IBrand) => {
    setSelectedBrand(brand);
    setOpenModal(true);
  };
  return (
    <>
      <ListTable
        headerCells={headerCells}
        rows={brands}
        isLoading={isLoading}
        actions={actions}
        renderCell={(brand: IBrand, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return (
                <Box display="flex" justifyContent="center">
                  <Avatar
                    src={brand.brandLogoUrl || undefined}
                    alt={brand.name}
                    variant="rounded"
                    imgProps={{ style: { objectFit: 'contain' } }}
                    sx={{
                      width: 48,
                      height: 48,
                      flexShrink: 0,
                      bgcolor: 'transparent',
                      color: '#8A8D91',
                      fontSize: 16,
                      fontWeight: 700,
                    }}
                  >
                    {brand.name?.charAt(0)?.toUpperCase() || '?'}
                  </Avatar>
                </Box>
              );
            case 1:
              return (
                <span style={{ color: '#0BE600' }}>
                  {capitalizeWords(brand.name) || 'N/A'}
                </span>
              );

            case 2:
              return formatDateAndTime(brand.updatedAt) || 'N/A';
            case 3:
              return formatDateAndTime(brand.createdAt) || 'N/A';
            case 4:
              return brand.errorCodeCount || '0';
            case 5:
              return (
                <Button
                  variant="outlined"
                  size="small"
                  color={brand.isActive ? 'error' : 'success'}
                  onClick={() => handleOpenModal(brand)}
                  sx={{
                    textTransform: 'none',
                    fontSize: '0.8rem',
                    borderRadius: '8px',
                  }}
                >
                  {brand.isActive ? 'Disable' : 'Enable'}
                </Button>
              );

            default:
              return null;
          }
        }}
      />

      <ModalConfirmation
        open={openModal}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        selectedItem={selectedbrand}
        entityName="brand"
      />
    </>
  );
};
